/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Header } from "../../common/header";
import { NotificationProvider } from "../../../contexts/notification-context";
import { TApiLab } from "../../../lib/types/labs";
import { useLabs } from "../../../services/laboratories";

import { Footer } from "../main-page/footer";
import { Spinner } from "../../common/spinner";

import { WelcomeLabModal } from "../../common/welcomeModal";
//import { StripeSetupIntent } from "../../common/stripe/stripe-setup-intent";
//import { useSubscriptionService } from "../../../services/subscriptions";
import { LabInfo, TDentalLabInfoProps } from "./lab-info";
declare global {
    interface Window {
        wwgLabInfo_dataWasModified: boolean;
    }
}

dayjs.extend(utc);

export const DentalLabInfo = ({ editable = false }: Pick<TDentalLabInfoProps, "editable">) => {
    const { userId } = useParams();
    const { getLab, state } = useLabs();
    const [labInfo, setLabInfo] = useState<TApiLab[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [labName, setLabName] = useState("");

    useEffect(() => {
        const isFirstLogin = localStorage.getItem("firstLogin");
        const savedName = localStorage.getItem("labName");
        if (isFirstLogin) {
            setShowModal(true);
            setLabName(savedName || "");
            localStorage.removeItem("firstLogin");
            localStorage.removeItem("labName");
        }
    }, []);

    useEffect(() => {
        if (userId) {
            getLab(Number(userId)).then((info) => {
                setLabInfo(info);
                setLabName(info[0].name);
            });
        }
    }, [userId]);

    return (
        <NotificationProvider>
            <Header title="" />
            {showModal && <WelcomeLabModal labName={labName} />}
            {state === "working" && (
                <div className="text-center">
                    <Spinner spinnerColor="text-primary" />
                </div>
            )}
            {state !== "working" && (
                <>
                    {/* <StripeComponent /> */}
                    <LabInfo editable={editable} labExist={userId === undefined ? true : labInfo.length > 0} labInfo={labInfo[0]} />
                </>
            )}
            <Footer />
        </NotificationProvider>
    );
};
